<template>
  <v-card class="auth-basic-info pa-3">
    <v-card-title class="pb-0">
      <h2>Update your Password</h2>
      <p>
        Update your password here. You will need to insert your old password for
        security purposes.
      </p>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col sm="6" cols="12">
          <v-text-field
            ref="new_password"
            v-model="new_password"
            name="new_password"
            label="Enter your NEW password"
            hint="Make sure your password is 6 to 20 characters long"
            min="6"
            :append-icon="new_visible ? 'visibility' : 'visibility_off'"
            @click:append="new_visible = !new_visible"
            :error-messages="errors.collect('new_password')"
            v-validate="'required|min:6|max:20'"
            data-vv-name="new_password"
            data-vv-as="NEW password"
            required
            :type="new_visible ? 'text' : 'password'"
          />
        </v-col>
        <v-col sm="6" cols="12">
          <v-text-field
            v-model="new_password_confirmation"
            name="new_password_confirmation"
            label="Confirm your NEW password"
            hint="Make sure your password is 6 to 20 characters long"
            min="6"
            :append-icon="new_confirm_visible ? 'visibility' : 'visibility_off'"
            @click:append="new_confirm_visible = !new_confirm_visible"
            :error-messages="errors.collect('new_password_confirmation')"
            v-validate="'required|confirmed:new_password'"
            data-vv-name="new_password_confirmation"
            data-vv-as="NEW password confirmation"
            required
            :type="new_confirm_visible ? 'text' : 'password'"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            ref="password"
            v-model="password"
            name="password"
            label="Enter your OLD password"
            min="6"
            :append-icon="visible ? 'visibility' : 'visibility_off'"
            @click:append="visible = !visible"
            :error-messages="errors.collect('password')"
            v-validate="'required|min:6|max:20'"
            data-vv-name="password"
            data-vv-as="OLD password"
            required
            :type="visible ? 'text' : 'password'"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="disabled"
        class="button_google_tag_manager"
        data-category="user"
        data-action="click"
        data-label="update profile"
      >
        Update
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Auth from '@/modules/auth/models/Auth'
import { mapMutations } from 'vuex'

export default {
  name: 'PasswordInfo',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      new_password: null,
      new_password_confirmation: null,
      password: null,
      new_visible: false,
      new_confirm_visible: false,
      visible: false,
      loading: false
    }
  },
  computed: {
    me() {
      let type = this.$route.meta.type
      if (type == 'user') type = 'student'
      return Auth.query()
        .where('type', type)
        .first()
    },
    disabled() {
      if (this.loading) {
        return true
      }

      if (
        !this.new_password ||
        !this.new_password_confirmation ||
        !this.password
      ) {
        return true
      }

      return false
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showErrorSnackbar', 'showSnackbar']),
    async submit() {
      let result = await this.$validator.validateAll()

      if (!result) return

      const payload = {
        current_password: this.password,
        new_password: this.new_password,
        new_password_confirmation: this.new_password_confirmation
      }

      try {
        this.loading = true
        await Auth.dispatch('updateProfile', {
          payload: payload,
          type: `${this.me.type}s`
        })
        this.loading = false
        this.new_password = null
        this.new_password_confirmation = null
        this.password = null
        this.new_visible = false
        this.new_confirm_visible = false
        this.visible = false
        this.showSnackbar('Password updated successfully.')
      } catch (error) {
        console.log(error.data)
        this.showErrorSnackbar('There was an error.')
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.auth-basic-info {
  h2 {
    display: block;
    width: 100%;
    font-size: 1em;
  }

  p {
    padding: 0;
    margin: 0;
    font-size: 1rem;
  }
}
</style>
